<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="800" persistent>
      <v-card min-height="700">
        <v-card-text>
          <div id="pallet-3d">
            <PalletViewing v-if="pallet" :pallet="pallet" />
          </div>
        </v-card-text>

        <div class="cancel-button">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-btn color="red" @click="dialog = false" v-on="on">
                <v-icon color="white">close</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("pallets_maker.cancel") }}</span>
          </v-tooltip>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PalletViewing from "@/components/palleting/PalletViewing.vue";
export default {
  data() {
    return {
      dialog: false,
      pallet: null,
      onKeyUp: e => {
        if (e.key === "Escape") {
          this.dialog = false;
        }
      }
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        this.pallet = null;
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    }
  },
  methods: {
    open(pallet) {
      this.dialog = true;
      this.pallet = pallet;
    }
  },
  components: {
    PalletViewing
  }
};
</script>

<style scoped>
#pallet-3d {
  position: absolute;
  margin-left: 25px;
  width: 700px;
  height: 600px;
}
</style>